import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface LocationChargePointListUpdateFormStep1SelectHeaderProps
  extends HeaderContext<GatewayChargePointModel, unknown> {}

export const LocationChargePointListUpdateFormStep1SelectHeader =
  (): // props: LocationChargePointListUpdateFormStep1SelectHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
